import React, { Component } from 'react';

import { Section } from 'components/section/section';

import { size, isEqual, map, filter } from 'lodash';

import styles from './talent.module.scss';
import { NoteFormContainer } from '../../containers/noteFormContainer/noteFormContainer';
import { NotesList } from '../notesList/notesList';
import dayjs from 'dayjs';
import candidates from '../../redux/modules/candidates';
import users from '../../redux/modules/users';
import notes from '../../redux/modules/notes';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useState } from 'react';
var relativeTime = require('dayjs/plugin/relativeTime');

export const TalentNotes = (props) => {
  const { talent, isNoteFormOpen, onFormOpen, onNoteDelete, userId, isLoading, userNotes } = props;

  const [initialValue, setInitialValue] = useState(null);
  
  // Fetch candidate-specific notes using the correct API parameter
  // API expects: GET /rest/notes?user_id={candidateUserId}
  const {
    data: notesData,
    error: notesError,
    isFetching: isLoadingNotes,
    refetch: refetchNotes,
  } = notes.list().useNotelistQuery(
    {
      params: { user_id: userId }
    },
    {
      selectFromResult: ({ data, error, isFetching }) => ({
        data: data?.data || [],
        error,
        isFetching,
      }),
      skip: !userId, // Don't fetch if no userId
    }
  );
  
  // Force refetch when userId changes to ensure fresh candidate-specific data
  useEffect(() => {
    if (userId) {
      refetchNotes();
    }
  }, [userId, refetchNotes]);

  const [deleteNote, noteDeleteData] = notes.delete().useNotedeleteMutation();

  const getTalentNotes = () => {
    dayjs.extend(relativeTime);

    // Use the candidate-specific notes data from RTK Query
    const allNotes = notesData || [];
    
    // Filter to only show notes where user_id matches the current candidate
    const candidateNotes = allNotes.filter(note => note.user_id === userId);
    
    // Sort by created date (newest first)
    const sortedNotes = [...candidateNotes].sort((a, b) => 
      new Date(b.created) - new Date(a.created)
    );
    
    // Transform notes for display
    return sortedNotes.map((note) => ({
      id: note.id,
      note: note?.note === 'emptyNote' ? 'N/A' : note?.note,
      attachment: note.attachment,
      author: note.author,
      created: note?.created && dayjs(note.created).toNow(true),
    }));
  };

  useEffect(() => {
    if (noteDeleteData) {
      if (noteDeleteData?.isSuccess) {
        toast.success('Note Deleted SuccessFully!');
      }
      if (noteDeleteData?.error) {
        toast.error('Failed To Delete Note!');
      }
    }
  }, [noteDeleteData]);

  const onEditNote = (note) => {
    setInitialValue({
      note: note?.note,
      id: note?.id,
      attachment: note?.attachment,
      user_id: userId,
    });
  };
  return (
    <div className={styles.talentSidebarNotesWrapper}>
      <div className={styles.notesForm}>
        <NoteFormContainer
          userNotes={getTalentNotes()}
          initialValue={initialValue}
          // getNotes={getTalentNotes()}
          userId={userId}
          talent={talent}
          isOpen={isNoteFormOpen}
          onOpen={onFormOpen}
          className={styles.sidebarNoteForm}
          setInitialValue={setInitialValue}
        />
      </div>
      {isLoadingNotes ? (
        <h4>Loading...</h4>
      ) : (
        <Section
          title="Notes & Attachments"
          count={size(getTalentNotes())}
          headingSize="large"
          isToggleable
        >
          {notes && (
            <NotesList
              userId={userId}
              notes={getTalentNotes()}
              onDeleteNote={(id) => deleteNote({ body: { id: id } })}
              onEditNote={onEditNote}
            />
          )}
        </Section>
      )}
    </div>
  );
};
